import { MRT_SortingState } from "mantine-react-table"
import { ActivityDto } from "../../../../../@client/Theasoft_ApiServer_Activities"
import { useActivityTableColumns } from "./use-activity-table-columns"
import {
  ExtendedInfinitScrollingTable,
  ExtendedTableProps,
} from "../../../-components/infinit-scrolling-table/extended-infinit-scrolling-table"

const route = "/api/Activity/GetActivityTable"

export function ExtendedActivityTable(
  props: ExtendedTableProps<typeof route, ActivityDto>
) {
  const { extendedColumns, defaultColumnVisibility } = useActivityTableColumns()

  const defaultSorting = React.useMemo<MRT_SortingState>(
    () => [{ id: "date", desc: false }],
    []
  )

  return (
    <ExtendedInfinitScrollingTable
      url={route}
      defaultSorting={defaultSorting}
      defaultColumVisibility={defaultColumnVisibility}
      columnDefinitions={extendedColumns}
      {...props}
    />
  )
}
